import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { BRAND, LOGO_URL, PHONE_DISPLAY, PHONE_TEL } from "../../data/menu";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3"
        >
          <img
            src={LOGO_URL}
            alt={BRAND}
            className="h-10 md:h-14 w-auto object-contain drop-shadow-[0_0_16px_rgba(230,57,70,0.35)]"
          />
        </a>

        <nav className="hidden md:flex items-center gap-10 font-body text-sm uppercase tracking-widest text-[#a8a8a8]">
          <a href="#menu" data-testid="nav-menu-link" className="hover-underline hover:text-white transition-colors">
            Menu
          </a>
          <a href="#why" data-testid="nav-why-link" className="hover-underline hover:text-white transition-colors">
            Why Us
          </a>
          <a href="#order" data-testid="nav-order-link" className="hover-underline hover:text-white transition-colors">
            Order
          </a>
        </nav>

        <a
          href={`tel:${PHONE_TEL}`}
          data-testid="nav-call-button"
          className="group inline-flex items-center gap-2 rounded-full bg-[#e63946] px-4 py-2 md:px-6 md:py-3 font-body font-semibold uppercase tracking-wider text-white text-xs md:text-sm transition-all duration-300 hover:bg-[#ffb703] hover:text-black focus:outline-none focus:ring-2 focus:ring-[#ffb703] focus:ring-offset-2 focus:ring-offset-black"
        >
          <Phone className="h-4 w-4 transition-transform group-hover:rotate-12" />
          <span className="hidden sm:inline">{PHONE_DISPLAY}</span>
          <span className="sm:hidden">Call</span>
        </a>
      </div>
    </motion.header>
  );
};
